<div mat-dialog-title>
  <h2 mat-dialog-title>{{data.title}}</h2>
</div>

<mat-dialog-content>{{data.content}}</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end">
  <button mat-button [mat-dialog-close]="false">{{data.actionOneCaption}}</button>
  <button mat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{data.actionTwoCaption}}</button>
</div>